function collectionSliderDebounce(fn, wait) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CollectionSlider extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.slider = null;
    this._onResize = collectionSliderDebounce(() => {
      this.reinit();
    }, 200);
    window.addEventListener('resize', this._onResize);
    this.initWhenReady();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    if (this.slider) {
      try {
        this.slider.destroy();
      } catch (e) {}
      this.slider = null;
    }
  }

  initWhenReady() {
    if (typeof Flickity === 'undefined') {
      setTimeout(() => this.initWhenReady(), 50);
      return;
    }
    this.initialize();
  }

  reinit() {
    if (this.slider) {
      try {
        this.slider.destroy();
      } catch (e) {}
      this.slider = null;
    }
    this.initialize();
  }

  initialize() {
    if (typeof Flickity === 'undefined') return;

    const options = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      wrapAround: true,
      groupCells: 6,
    };

    if (matchMedia('(max-width: 1024px)').matches) {
      options.groupCells = 4;
      options.dragThreshold = 10;
    }

    if (matchMedia('(max-width: 767px)').matches) {
      options.groupCells = 2;
    }

    try {
      this.slider = new Flickity(this, options);
      this.classList.add('is-ready');
      this.alignButtonsToImage();
      requestAnimationFrame(() => this.alignButtonsToImage());
      this.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => this.alignButtonsToImage(), { once: true });
        }
      });
    } catch (e) {
      this.classList.add('is-ready');
      console.warn('CollectionSlider init failed', e);
    }
  }

  alignButtonsToImage() {
    const media =
      this.querySelector('.collection-slide.is-selected .box--3') ||
      this.querySelector('.collection-slide .box--3') ||
      this.querySelector('.collection-slide .card-image') ||
      this.querySelector('.collection-slide .ratio--product');

    if (!media) return;

    const sliderRect = this.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();
    const centerY = mediaRect.top - sliderRect.top + mediaRect.height / 2;

    this.style.setProperty('--collection-slider-button-top', `${Math.max(Math.round(centerY), 0)}px`);
  }
}

customElements.define('collection-slider', CollectionSlider);
